import Vue from "vue";
import VueRouter from "vue-router";

// 引入组件
import page_index from "@/containers/Index/Index";
import page_flow from "@/containers/Advantage/Flow";
import page_ai from "@/containers/Advantage/Ai";
import page_dimension from "@/containers/Advantage/Dimension";
import page_content from "@/containers/Advantage/Content";
import page_case from "@/containers/Case/Case";
import page_case_content from "@/containers/Case/CaseContent";
import page_news from "@/containers/News/News";
import page_news_content from "@/containers/News/NewsContent";
import page_about from "@/containers/About/About";
import page_flow_to_cash from "@/containers/Flow/FlowToCash";
import page_sdk_privacy_agreement from "@/containers/PrivacyAgreement/SdkPrivacyAgreement";

// 要告诉 vue 使用 vueRouter
Vue.use(VueRouter);

const routes = [
    // 首页，默认首页
    {
        path: '/',
        redirect: '/index'
    },
    // 首页
    {
        path:"/index",
        component: page_index
    },
    // 品质流量
    {
        path:"/flow",
        component: page_flow
    },
    // ai赋能
    {
        path:"/ai",
        component: page_ai
    },
    // 内容场景
    {
        path:"/content",
        component: page_content
    },
    // 多维服务
    {
        path:"/dimension",
        component: page_dimension
    },
    // 成功案例
    {
        path:"/case",
        component: page_case
        // props: true
    },
    // 成功案例-具体案例
    {
        path:"/case_content/:id",
        component: page_case_content,
    },
    // 流量变现
    {
        path:"/flow_to_cash",
        component: page_flow_to_cash
    },
    // 新闻资讯
    {
        path:"/news",
        component: page_news,
    },
    // 新闻资讯-具体新闻
    {
        path:"/news_content/:id",
        component: page_news_content
    },
    // 关于我们
    {
        path:"/about",
        component: page_about
    },
	{ // 隐私协议-sdk
		path:"/page_sdk_privacy_agreement",
		component: page_sdk_privacy_agreement
	}
]

var router =  new VueRouter({
    // mode: 'history',
    routes,
    // scrollBehavior (to, from, savedPosition) {
    //     console.log(111)
    //     if (savedPosition) {
    //         to.meta.saved_position = savedPosition;
    //         // 现在原页面滚动 如果滚动高度超过页面自身高度，就回到顶部
    //         // return savedPosition;
    //         window.scrollTo(savedPosition.x, savedPosition.y);
    //     } else {
    //         window.scrollTo(0, 0);
    //     }
    // }
})
// 全局路由守卫
router.beforeEach((to, from, next) => {
    next();
})
router.afterEach((to, from, next) => {
    // 置顶
    window && window.scrollTo(0, 0);
    document && document.documentElement.click();
    // next();
})
export default router;



// WEBPACK FOOTER //
// ./src/router.js